import { Link, type LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { createLink, type LinkComponent } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ChakraLinkComponent = forwardRef<HTMLAnchorElement, ChakraLinkProps>(
  (props, ref) => {
    return <Link ref={ref} {...props} />;
  },
);

const CreatedLinkComponent = createLink(ChakraLinkComponent);

export const StyledLink: LinkComponent<typeof ChakraLinkComponent> = (
  props,
) => {
  return (
    <CreatedLinkComponent
      _hover={{ textDecor: 'none', ...props._hover }}
      {...props}
    />
  );
};
